import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import simplebar from "simplebar-vue";
  import "simplebar-vue/dist/simplebar.min.css";
  import { onMounted, ref } from "vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomScrollbar',
  emits: ["scrollerComponent"],
  setup(__props, { emit: __emit }) {

  const emit = __emit;
  const scroller = ref<typeof simplebar>();

  onMounted(() => {
    emit("scrollerComponent", scroller);
    scroller.value?.SimpleBar.el?.classList.remove("load");
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(simplebar), {
    class: "custom-scrollbar-wrapper",
    "data-simplebar-auto-hide": "false",
    ref_key: "scroller",
    ref: scroller
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 512))
}
}

})